import { doGetOld } from '@/services/api/base'

/**
 * Ping the API
 * @returns Promise<any> The response from the API
 */
export const ping = async (): Promise<any> => {
  return await doGetOld('/api/ping')
}
